import React, { useState } from "react";
import CustomModal from "../../Common-Modal/CustomModal";
import { Button, Col, DatePicker, Icon, message, Row, Spin } from "antd";
import moment from "moment";
import { DATE_FORMAT, NO_DATA_FOUND, REPORT_EXPORTED_SUCCESSFULLY } from "../../utils/Constants";
import axios from "axios";
import { DOWNLOAD_REPORT_API_URL } from "../../utils/Api_enums";

const today = new Date();

const DownloadModal = (props) => {
  const { visible, setIsVisible, agency_id } = props;
  const [datemodified, setdatemodified] = useState({
    start_date: ("2010-01-01"),
    end_date: ("2050-01-01"),
    period: "from_to",
  });
  const [activebtn, setActivebtn] = useState(0);
  const [excelLoading, setExcelLoading] = useState(false)
  // const [filetype, setFiletype] = useState("")

  const onChangeDate = (date, name) => {
    let { start_date, end_date, period } = datemodified;

    if (date === null && name === "start_date") {
      setdatemodified(prevState => ({
        ...prevState,
        start_date: ("2010-01-01"),
      }))
      return;
    }
    else if (date === null && name === "end_date") {
      setdatemodified(prevState => ({
        ...prevState,
        end_date: ("2050-01-01"),
      }))
      return
    }

    date = date ? moment(date).format("YYYY-MM-DD") : null;
    start_date = start_date ? moment(start_date).format("YYYY-MM-DD") : null;
    end_date = end_date ? moment(end_date).format("YYYY-MM-DD") : null;

    let obj = {};

    if (["start_date", "end_date"].includes(name) && !date) {
      start_date = moment(
        new Date(today.getFullYear(), today.getMonth(), 1)
      ).format("YYYY-MM-DD");
      end_date = moment(
        new Date(today.getFullYear(), today.getMonth() + 1, 0)
      ).format("YYYY-MM-DD");
      period = "mtd";

      obj = { period, start_date, end_date };
    } else {
      period = "from_to";
      obj = { period };

      if (name === "start_date" && date && end_date) {
        obj.start_date = date;
        obj.end_date = end_date;
      }

      if (name === "end_date" && date && start_date) {
        obj.end_date = date;
        obj.start_date = start_date;
      }
    }

    setdatemodified(obj);
  };

  const refreshStats = () => {
    let obj = {
      start_date: moment(("2010-01-01")).format("YYYY-MM-DD"),
      end_date: moment(("2050-01-01")).format("YYYY-MM-DD"),
      period: "from_to",
    };
    setdatemodified(obj);
    setActivebtn(0)
  };


  const thisMonthReportFunc = () => {
    const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
    const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
    setdatemodified({
      start_date: startOfMonth,
      end_date: endOfMonth
    })
  }


  const downloadReport = async (filetype) => {

    const formattedStartDate = moment(datemodified.start_date, "YYYY-MM-DD", true);
    const formattedEndDate = moment(datemodified.end_date, "YYYY-MM-DD", true);


    if (formattedStartDate.isValid() && formattedEndDate.isValid()) {
      // Perform the comparison
      if (formattedStartDate.isAfter(formattedEndDate)) {
        message.destroy()
        message.error("Start date cannot be greater than the end date.");
        return;
      }
    }

    const data = {
      start_date: datemodified.start_date,
      end_date: datemodified.end_date,
      filetype: filetype,
      agency_id: agency_id
    }
    try {
      setExcelLoading(true)
      const response = await axios.post(`${DOWNLOAD_REPORT_API_URL}`, data, {
        responseType: 'blob',
      });
      if (response.data.type == "application/json") {
        message.error(NO_DATA_FOUND);
        return;
      }
      let fileExtension = filetype === 'csv' ? '.csv' : '.xlsx';

      // Create a Blob URL from the response data
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;

      link.setAttribute('download', `B File Report for ${moment(datemodified.start_date).format(DATE_FORMAT)} to ${moment(datemodified.end_date).format(DATE_FORMAT)}${fileExtension}`);

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);


    } catch (error) {
      console.error('Error downloading report:', error);
      if (error.response && error.response.data instanceof Blob) {
        const errorText = await error.response.data.text();
        try {
          const errorJson = JSON.parse(errorText);
          message.destroy()
          console.error('Error Message:', errorJson.message || errorJson.error || errorJson);
          message.error(errorJson.message || errorJson.error || errorJson)
        } catch (e) {
          console.error('Raw Error Text:', errorText);
        }
      } else {
        console.error('Error:', error.message);
      }
    } finally {
      setExcelLoading(false);
    }

  }



  const allBFilesFunc = () => {
    let obj = {
      start_date: moment(("2010-01-01")).format("YYYY-MM-DD"),
      end_date: moment(("2050-01-01")).format("YYYY-MM-DD"),
      period: "from_to",
    };
    setdatemodified(obj)
  }


  return (

    <CustomModal
      title={"Export B File Report"}
      isVisible={visible}
      setIsVisible={setIsVisible}
      className="download-modal"
      width="400px"
    >
      <Spin spinning={excelLoading}>
        <div className="modal-content" style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {/* Row 1: Buttons */}
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'space-between' }}>
            <Button
              className={`download-btn ${activebtn === 0 ? "download-active-btn" : ""}`}
              onClick={() => {
                setActivebtn(0);
                allBFilesFunc();
              }}
              style={{ flex: 1 }}
            >
              All B Files
            </Button>

            <Button
              className={`download-btn ${activebtn === 1 ? "download-active-btn" : ""}`}
              onClick={() => {
                setActivebtn(1);
                thisMonthReportFunc();
              }}
              style={{ flex: 1 }}
            >
              This Month
            </Button>
          </div>

          {/* Row 2: Date Pickers */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
            <div>
              <div className="datepicker-label" style={{ marginBottom: '4px' }}>Start Date</div>
              <DatePicker
                value={(datemodified.start_date && moment(datemodified.start_date)) || null}
                format={DATE_FORMAT}
                onChange={(e) => onChangeDate(e, "start_date")}
                className="datepicker"
                style={{ width: '100%' }}
              />
            </div>

            <div>
              <div className="datepicker-label" style={{ marginBottom: '4px' }}>End Date</div>
              <DatePicker
                value={(datemodified.end_date && moment(datemodified.end_date)) || null}
                format={DATE_FORMAT}
                className="datepicker"
                onChange={(e) => onChangeDate(e, "end_date")}
                style={{ width: '100%' }}
              />
            </div>
          </div>

          {/* Row 3: Refresh Button */}
          <Button
            type="primary"
            className="refresh-con"
            onClick={refreshStats}
            style={{ width: '100%', borderRadius: '20px' }}
          >
            Refresh
            <Icon type="reload" />
          </Button>

          {/* Row 4: Download Buttons */}
          <div style={{ display: 'flex', gap: '12px' }}>
            <Button
              className="download-btn download-btn-hover"
              onClick={() => downloadReport("csv")}
              style={{ flex: 1 }}
            >
              Download as CSV
            </Button>

            <Button
              className="download-btn download-btn-hover"
              onClick={() => downloadReport("excel")}
              style={{ flex: 1 }}
            >
              Download as Excel
            </Button>
          </div>
        </div>
      </Spin>
    </CustomModal>


  );
};

// Responsive styles
const styles = `
  .download-modal .ant-modal {
    width: 400px !important;
    max-width: 90%;
  }
  
  @media (max-width: 768px) {
    .download-modal .ant-modal {
      margin: 10px auto;
    }
    
    .datepicker {
      width: 100% !important;
    }
  }
  
  @media (max-width: 480px) {
    .modal-content > div {
      flex-direction: column;
    }
    
    .modal-content button {
      width: 100% !important;
    }
    
    .ant-modal-title {
      font-size: 16px;
    }
  }
`;

// Add styles to the document head
const styleElement = document.createElement('style');
styleElement.textContent = styles;
document.head.appendChild(styleElement);

export default DownloadModal;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/DownloadModal.js